import React from "react";
import { Alert, Row, Col, Statistic } from "antd";
import CountUp from "react-countup";

const formatter = (value) =>
    typeof value === "number" ? (
        <CountUp end={value} separator="," useEasing={true} useGrouping={true} duration={2} />
    ) : (
        value
    );


const BiotechDataSummary = ({ data }) => {
    if (!data || data.length === 0) return null;

    const uniqueCompanies = new Set(data.map((row) => row.company_name)).size;
    const totalSubstances = data.length;

    const substancesPerPhase = data.reduce((acc, row) => {
        acc[row.phase] = (acc[row.phase] || 0) + 1;
        return acc;
    }, {});

    return (
        <div style={{ marginBottom: 20, textAlign: "left" }}>
            <div style={{padding: 20, background: "#f0f2f5", borderRadius: 8}}>
                <Row gutter={16}>
                    <Col span={10}>
                        <p>
                            This website provides insights into Swedish biotech companies, their market capitalization,
                            and drug development phases. We built this to help visualize and explore the Swedish biotech
                            landscape.
                        </p>
                        <p>
                            The data is based on <a
                            href="https://swedenbio.se/"
                            rel="noopener noreferrer"
                            target="_blank">SwedenBIO's</a> 2023 pipeline report, which shows that 154 Swedish R&D
                            pharma and biotech companies are actively developing new drugs.
                        </p>
                        <p>
                            Read the full report in <a
                            href="https://swedenbio.se/wp-content/uploads/2023/03/report-the-swedish-drug-discovery-and-development-pipeline-2023-1.pdf"
                            target="_blank"
                            rel="noopener noreferrer"
                        >The Swedish Drug Discovery and Development Pipeline 2023</a> from SwedenBIO, the national non-profit
                            association for the life science industry in Sweden.
                        </p>
                        <p>Market cap is updated 2025-02-01.</p>
                        <br/>
                        <p><b>Stats</b></p>
                    </Col>
                </Row>

                <Row gutter={16}>
                <Col span={8}>
                        <Statistic title="Total Companies" value={uniqueCompanies} formatter={formatter}/>
                        <Statistic title="Total Substances" value={totalSubstances} formatter={formatter}/>
                    </Col>
                </Row>
                <p>Substances Per Phase</p>
                <Row gutter={16}>
                    {Object.entries(substancesPerPhase).sort(([a], [b]) => {
                        const order = {"Discovery": 1, "Preclinical": 2, "Phase I": 3, "Phase II": 4, "Phase III": 5};
                        return (order[a] || 99) - (order[b] || 99);
                    }).map(([phase, count]) => (
                        <Col span={2} key={phase}>
                            <Statistic title={phase} value={count} formatter={formatter} />
                        </Col>
                    ))}
                </Row>

            </div>
        </div>
    );
};

export default BiotechDataSummary;